const WEIGHTS = [0.4, 0.65, 1, 0.7, 0.45];

interface Props {
  level?: number;
  active?: boolean;
}

export default function VoiceLevelBars({ level = 0, active = false }: Props) {
  const scaled = active ? 0.16 + Math.min(1, Math.max(0, level)) * 0.84 : 0.16;

  return (
    <span className="inline-flex h-[18px] items-center justify-center gap-0.5" aria-hidden="true">
      {WEIGHTS.map((weight, index) => (
        <span
          key={index}
          className="w-[3px] rounded-[1.5px] bg-x9-marine"
          style={{
            height: 14,
            transform: `scaleY(${scaled * (0.45 + weight * 0.55)})`,
            transformOrigin: 'center',
            transition: 'transform 70ms linear',
          }}
        />
      ))}
    </span>
  );
}
